var map = {
	"./Clear.png": 63,
	"./Cloud-background.png": 11,
	"./Clouds.png": 64,
	"./Drizzle.png": 65,
	"./Fog.png": 66,
	"./Hail.png": 67,
	"./Haze.png": 68,
	"./Mist.png": 69,
	"./Rain.png": 70,
	"./Shower.png": 71,
	"./Sleet.png": 72,
	"./Snow.png": 73,
	"./Thunderstorm.png": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;